// extracted by mini-css-extract-plugin
export var active = "_cr-2";
export var recordingDot = "_cr-1";
export var recordingIndicator = "_cr-0";